import { SiretHttp } from '../models/siret-http.dto';
import { Siret } from '../models/siret.model';

export const fromSiretHttpToSiret = (siretHttp: SiretHttp): Siret => {
  return {
    name: siretHttp.name,
    industryType: siretHttp.industry_type,
    legalStatus: siretHttp.legal_status,
    taxCode: siretHttp.tax_code,
    registrationNumber: siretHttp.registration_number,
    addressLine1: siretHttp.address_line_1,
    addressLine2: siretHttp.address_line_2,
    addressLine3: siretHttp.address_line_3,
    city: siretHttp.city,
    postalCode: siretHttp.postal_code,
  };
};
